import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { ApolloClientProvider } from './apollo';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import 'moment/locale/fr';

moment.locale('fr');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ApolloClientProvider>
    <App />
    </ApolloClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
